// extracted by mini-css-extract-plugin
export var overlayHeaderActionButton = "Iren1qajhVuFiHTdqftm";
export var overlayHeaderActionButtons = "x85dXDw9kDZD01INxQKK";
export var overlayHeaderBubble = "zu0X5AtDPAawO0Q_pqPw";
export var overlayHeaderContent = "J772HkE_UzCgU57MtHaA";
export var overlayHeaderShadow = "fAr1Jd0F4GLih3Dm3eqb";
export var root = "FYBfizLqgQnLJm4DBSmw";